export default __webpack_public_path__ + "static/media/irn.ad7a2d7f.svg";